import request from '@/utils/request'

let ExamApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._post('/shop/plus.exam.exam/index', data, errorback);
  },
  /*
    添加问题
  */
  add(data, errorback) {
    return request._post('/shop/plus.exam.exam/add', data, errorback);
  },
    /*
    修改问题
  */
    edit(data, errorback) {
      return request._post('/shop/plus.exam.exam/edit', data, errorback);
    },
  // 获取问题
  detail(data){
    return request._post('/shop/plus.exam.exam/detail', data);
  },
   // 删除问题
   del(data){
    return request._post('/shop/plus.exam.exam/del', data);
  },
   // 考试设置
   setting(data){
    return request._post('/shop/plus.exam.exam/setting', data);
  },
  //获取考试设置
  getSetting(data){
    return request._get('/shop/plus.exam.exam/setting', data);
  }

}

export default ExamApi;



// WEBPACK FOOTER //
// ./src/api/exam.js